<script>
	module.exports = {
		props: {
			showTitle: {
				default: false
			},
			scheduleToday: {
				default: false
			}
		}
	};
</script>
<style lang="scss">
	.student-knowledge-inventory-about-content {
		header.main-header h1 {
			clear: none;
			float: none;
		}
	}
</style>
<template>
	<div class="student-knowledge-inventory-about-content">
		<header
			v-if="showTitle"
			class="main-header">
			<h1 class="wrapper main-header-title">Reading Mindset Snapshot</h1>
		</header>
		<div
			:class="{
				wrapper: showTitle
			}">
			<template v-if="showTitle">
				<h3>Get to know your students as readers and watch them grow!</h3>
			</template>
			<p>The Reading Mindset Snapshot is a survey-style inventory designed to track:<br /></p>
			<ul>
				<li>Students’ joy in reading</li>
				<li>Topics they are interested in</li>
			</ul>
			<p></p>
			<p>Knowing this information gives teachers the tools to help students:<br /></p>
			<ul>
				<li>Read and comprehend challenging texts</li>
				<li>Choose texts for independent reading</li>
				<li>Enjoy reading more by tapping into their interests</li>
			</ul>
			<p>
				Learn more about the Snapshot and
				<a href="/teacher-guide/reading-mindset-snapshot.html">how to use it…</a>
			</p>
			<p v-if="scheduleToday">
				<a
					class="button"
					href="/assignments#!assignmentTab:rms">
					Schedule your Reading Mindset Snapshot today!
				</a>
			</p>
		</div>
	</div>
</template>
